var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79 88.75",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-727.000000, -102.000000)",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(728.400000, 103.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.709298,38.946969 C47.4562077,36.3179558 49.9980185,31.2080446 49.9980185,25.3351561 C49.9980185,16.7759424 43.0013706,13.9240261 37.9391777,13.9240261 C32.8769848,13.9240261 25.880337,16.7759424 25.880337,25.3351561 C25.880337,31.2080446 28.4221478,36.3179558 32.1690575,38.946969 C24.5216755,41.4147513 17.3600067,48.367113 17.3600067,56.5580579 C17.3600067,66.814218 27.6495922,67.8864788 37.9391777,67.8864788 C48.2287632,67.8864788 58.5183487,66.814218 58.5183487,56.5580579 C58.5183487,48.367113 51.35668,41.4147513 43.709298,38.946969 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.218296,23.6022799 C24.9196701,22.8216212 23.5431531,22.191845 22.1472152,21.741381 C25.2696399,19.5505366 27.3878156,15.2922773 27.3878156,10.3982035 C27.3878156,3.26552542 21.5572757,0.888928495 17.3387816,0.888928495 C13.1202875,0.888928495 7.28974764,3.26552542 7.28974764,10.3982035 C7.28974764,15.2922773 9.40792334,19.5505366 12.530348,21.741381 C6.15752975,23.7978662 0.189472429,29.5915009 0.189472429,36.4172883 C0.189472429,44.9640884 8.76412702,45.8576391 17.3387816,45.8576391 C18.785026,45.8576391 20.2312704,45.8322194 21.6363722,45.748946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.429079,23.5513776 C73.1554994,22.7942144 71.8086128,22.1820128 70.443144,21.741381 C73.5655687,19.5505366 75.6837444,15.2922773 75.6837444,10.3982035 C75.6837444,3.26552542 69.8532045,0.888928495 65.6347104,0.888928495 C61.4162163,0.888928495 55.5856764,3.26552542 55.5856764,10.3982035 C55.5856764,15.2922773 57.7038521,19.5505366 60.8262768,21.741381 C54.4534586,23.7978662 48.4854012,29.5915009 48.4854012,36.4172883 C48.4854012,44.9640884 57.0600558,45.8576391 65.6347104,45.8576391 C67.1029681,45.8576391 68.5712258,45.8314397 69.9964334,45.7451032",
    transform: "translate(62.084573, 23.373284) scale(-1, 1) translate(-62.084573, -23.373284) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ddeba5e990f9f1c00d3300f19b927117.svg";
export { ForwardRef as ReactComponent };